import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card",
  ref: "contentRef"
}
const _hoisted_2 = { class: "card-body pb-1" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "col-lg-5" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill fs-5 text-primary ms-2" }, null, -1)
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "col-lg-12" }
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = { class: "col-lg-3" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "col-lg-3" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = { class: "col-lg-4" }
const _hoisted_16 = { class: "col-lg-8" }
const _hoisted_17 = { class: "form-group row" }
const _hoisted_18 = { class: "col-lg-12" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-globe fs-2" }, null, -1)
const _hoisted_20 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_21 = { class: "mb-4" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "form-group row" }
const _hoisted_24 = { class: "col-lg-12" }
const _hoisted_25 = {
  key: 0,
  class: "d-flex align-items-center mb-6"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold me-3" }, "Estado", -1)
const _hoisted_27 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.gblDialog,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.gblDialog) = $event)),
    class: "bg-light rounded w-100 w-md-50 w-lg-50",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    top: "2vh",
    "lock-scroll": "",
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.gblDialog = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef))),
          loading: _ctx.loader
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.gblAction == 'new' ? _ctx.t('save') : _ctx.t('update')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        ref: "scrollbarRef",
        height: `${_ctx.altura - 300}px`,
        always: "",
        class: "bg-white rounded"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                ref: "ruleFormRef",
                model: _ctx.form,
                "status-icon": "",
                rules: _ctx.rules,
                class: "custom-label",
                "label-position": 'top',
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_form_item, {
                        prop: "country",
                        label: "Pais",
                        rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.country,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.country) = $event)),
                            "value-key": "idcountry",
                            filterable: "",
                            clearable: "",
                            placeholder: "Seleccione",
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `lr-${item.idcountry}`,
                                  label: `${item.idcountry} - ${item.name}`,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("label", _hoisted_6, [
                        _createTextVNode(_toDisplayString(_ctx.form.country?.fiscal_label) + " ", 1),
                        (_ctx.form.country?.idcountry)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              class: "box-item",
                              effect: "dark",
                              content: _ctx.form.country?.fiscal_name,
                              placement: "right"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_form_item, { prop: "ruc" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.ruc,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.ruc) = $event)),
                            modelModifiers: { trim: true },
                            disabled: !_ctx.form.country?.idcountry
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_form_item, {
                        prop: "name",
                        label: "Nombre",
                        rules: [{ required: true, message: 'campo requerido', trigger: ['blur', 'change'], }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_form_item, {
                        prop: "abrev",
                        label: "Siglas",
                        rules: [{ required: true, message: 'Campo requerido', tigger: ['blur', 'change'] }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.abrev,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.abrev) = $event)),
                            maxlength: "12"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_form_item, {
                        prop: "category",
                        label: "Categoría",
                        rules: [{ required: true, message: 'Campo requerido', tigger: ['blur', 'change'] }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.category,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.category) = $event)),
                            clearable: "",
                            placeholder: "Seleccionar",
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCategorie, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.iddetails,
                                  label: item.name,
                                  value: item.iddetails
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_form_item, {
                        prop: "instype",
                        label: "Ámbito",
                        rules: [{ required: true, message: 'Campo requerido', tigger: ['blur', 'change'] }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.instype,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.instype) = $event)),
                            clearable: "",
                            placeholder: "Seleccionar"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTypes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.iddetails,
                                  label: item.name,
                                  value: item.iddetails
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_form_item, {
                        prop: "idmatch",
                        label: "ID Match"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.idmatch,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.idmatch) = $event)),
                            maxlength: "9"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_form_item, {
                        prop: "idseat",
                        label: "Región"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.idseat,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.idseat) = $event)),
                            filterable: "",
                            clearable: "",
                            placeholder: "Seleccione",
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRegions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `lr-${item.idregion}`,
                                  label: item.name,
                                  value: item.idregion
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_form_item, {
                        prop: "siteweb",
                        label: "Sitio web"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.siteweb,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.siteweb) = $event))
                          }, {
                            prepend: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      link: "",
                      onClick: _ctx.addPhone,
                      disabled: !_ctx.form.country?.idcountry
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Agregar Teléfono")
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_el_table, {
                      data: _ctx.form.phone,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { label: "Tipo" }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              prop: `phone.${$index}.type`,
                              rules: [{ required: true, message: 'Campo requerido', tigger: ['blur', 'change'] }],
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: row.type,
                                  "onUpdate:modelValue": ($event: any) => ((row.type) = $event),
                                  placeholder: "Seleccione",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "Celular",
                                      value: "celular"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "Fijo",
                                      value: "fijo"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "Casa",
                                      value: "casa"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Código País" }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              prop: `phone.${$index}.countryCode`,
                              rules: [{ required: true, message: 'Campo requerido', tigger: ['blur', 'change'] }],
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: row.countryCode,
                                  "onUpdate:modelValue": ($event: any) => ((row.countryCode) = $event),
                                  modelModifiers: { trim: true },
                                  size: "small"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Número" }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              prop: `phone.${$index}.number`,
                              rules: [{ required: true, message: 'Campo requerido', tigger: ['blur', 'change'] }],
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: row.number,
                                  "onUpdate:modelValue": ($event: any) => ((row.number) = $event),
                                  modelModifiers: { trim: true },
                                  size: "small"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Acciones",
                          width: "100",
                          align: "center"
                        }, {
                          default: _withCtx(({ $index }) => [
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: "Eliminar",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: "bi bi-trash fs-2 text-danger me-3 cursor-pointer",
                                  onClick: ($event: any) => (_ctx.removePhone($index))
                                }, null, 8, _hoisted_22)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_el_form_item, {
                        prop: "address",
                        label: "Dirección"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.address,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.address) = $event)),
                            type: "textarea",
                            rows: 4
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (_ctx.form?.idinstitution)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_el_form_item, {
                          prop: "mstatus",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.form.mstatus,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.mstatus) = $event)),
                              placeholder: "Seleccione",
                              class: "w-200px"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: `s-${item.iddetails}`,
                                    label: item.name,
                                    value: item.iddetails
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model", "rules"])), [
                [_directive_loading, _ctx.loader]
              ])
            ])
          ], 512)
        ]),
        _: 1
      }, 8, ["height"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onClosed"]))
}